import React, { useEffect, useState } from 'react';
import './PopupCardContent.scss';
import useUiStateStore from '../../_store/useUiStateStore';

const PopupCardContent = (props) => {
    const { selectedCardItem } = props;
    const { isCheckupCardPopupOpen, setCheckupCardPopupOpen } = useUiStateStore();

    useEffect(() => {
        if(selectedCardItem.idx !== null) {
            setCheckupCardPopupOpen(selectedCardItem.isPopupOpen);
        }
    }, [selectedCardItem]);

    // mo CGM(연속혈당) 검사 popup
    const CGMPopupComponent = () => {
        return(
            <>
                <span>14일 간 시시각각 달라지는 내 혈당을 확인해보세요.</span>
                <ul className="tooltip-contents">
                    <li>
                        <em className="tit">허가번호</em>
                        <span className="desc">수허 23-397호</span>
                    </li>
                    <li>
                        <em className="tit">품목명</em>
                        <span className="desc">개인용체내연속혈당측정시스템​</span>
                    </li>
                    <li>
                        <em className="tit">모델명</em>
                        <span className="desc">FreeStyle Libre 2</span>
                    </li>
                    <li>
                        <em className="tit">수입업자</em>
                        <span className="desc">한국애보트(유)</span>
                    </li>
                    <li>
                        <em className="tit">제품명</em>
                        <span className="desc">프리스타일 리브레 2 연속 당 측정 시스템(FreeStyle Libre 2 Flash Glucose Monitoring System)</span>
                    </li>
                    <li>
                        <em className="tit">의료기기 표준코드(UDI)</em>
                        <span className="desc">05021791003785</span>
                    </li>
                </ul>
                <p className="notice">
                    <span>
                        이 제품은 "일회용 의료 기기"입니다. "재사용 금지"
                    </span>
                </p>
            </>
        );
    };

    // mo 심전도 검사 popup
    const CardiographyPopupComponent = () => {
        return (
            <>
                <span>심장 리듬의 모니터링을 통해 내 심장이 보내는 건강 신호를 확인해보세요​.</span>
                <ul className="tooltip-contents">
                    <li>
                        <em className="tit">허가번호</em>
                        <span className="desc">제인 21-4840호</span>
                    </li>
                    <li>
                        <em className="tit">품목명</em>
                        <span className="desc">홀터심전계​​</span>
                    </li>
                    <li>
                        <em className="tit">모델명</em>
                        <span className="desc">mobiCARE-MC200M</span>
                    </li>
                    <li>
                        <em className="tit">제조업자</em>
                        <span className="desc">(주)씨어스테크놀로지</span>
                    </li>
                    <li>
                        <em className="tit">의료기기 표준코드(UDI)</em>
                        <span className="desc">08800096400805</span>
                    </li>
                </ul>
                <p className="notice">
                    <span>
                        본 제품은 "의료기기"입니다.
                    </span>
                </p>
            </>
        );
    }

    const popupCloseBtnClick = () => {
        setCheckupCardPopupOpen(false);
    };

    const setDescComponent = () => {
        if(selectedCardItem.item.imgClassName === "cgm") {
            return CGMPopupComponent();
        } else if(selectedCardItem.item.imgClassName === "cardiogram") {
            return CardiographyPopupComponent();
        } else {
            return (
                <span>{selectedCardItem.item.desc}</span>
            );
        }
    };

    const setBadgeComponent = () => {
        if(selectedCardItem.item.imgClassName === "pms") {
            return (
                <>
                    <div className="tag-area pms">
                        <span>여성검사</span>
                    </div>
                </>
            );
        } else if (selectedCardItem.item.imgClassName === "prostate") {
            return (
                <>
                    <div className="tag-area prostate">
                        <span>남성검사</span>
                    </div>
                </>
            );
        } else {
            return (<></>);
        }
    }

    return (
        <> 
            { isCheckupCardPopupOpen ? ( 
                <div className="checkup-card">
                    <li className={`checkup-card-content ${selectedCardItem.item.imgClassName}`}> 
                        <div className="title-area">
                            <div>
                                <span className={`ico ${selectedCardItem.item.imgClassName}`}></span>
                                <strong>
                                    {selectedCardItem.item.cardName.split('<br/>').map((line, idx) => (
                                        <React.Fragment key={idx}>
                                            {line}
                                        </React.Fragment>
                                    ))}
                                    </strong>
                            </div>
                            <button className="btn-modal-close" onClick={popupCloseBtnClick}>
                                <img alt=""/>
                                <span className="blind">닫기</span>
                            </button>
                        </div>
                        <div className="desc-area checkup-card">
                            {setDescComponent()}
                        </div>
                        {setBadgeComponent()}
                    </li>
                </div>
            ) : (
                <></>
            )}
        </>
    )
}

export default PopupCardContent;
